var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#DAE7FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 20L23.9999 20",
    stroke: "#004FC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H13.3333",
    stroke: "#004FC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 21.6673C15.9204 21.6673 16.6666 20.9211 16.6666 20.0007C16.6666 19.0802 15.9204 18.334 14.9999 18.334C14.0794 18.334 13.3333 19.0802 13.3333 20.0007C13.3333 20.9211 14.0794 21.6673 14.9999 21.6673Z",
    stroke: "#004FC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 16H23.9999",
    stroke: "#004FC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16H16.6667",
    stroke: "#004FC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 17.6673C21.9204 17.6673 22.6666 16.9211 22.6666 16.0007C22.6666 15.0802 21.9204 14.334 20.9999 14.334C20.0794 14.334 19.3333 15.0802 19.3333 16.0007C19.3333 16.9211 20.0794 17.6673 20.9999 17.6673Z",
    stroke: "#004FC6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersIcon);
export default __webpack_public_path__ + "static/media/filters-icon.c86267eea01b2aa7062d236e36c9b1c4.svg";
export { ForwardRef as ReactComponent };